import RoutingEventType from 'models/routing_event/routing_event_type';

import createEnum from 'scripts/lib/create_enum';
export const NotificationSoundType = createEnum('DECLINED_SESSION_REASSIGNMENT', 'INCOMING_CONCURRENT_MESSAGE');

export function getNotificationType(type) {
  switch (type) {
    case RoutingEventType.INCOMING_CONCURRENT_MESSAGE:
    case RoutingEventType.INCOMING_CONCURRENT_SESSION:
      return NotificationSoundType.INCOMING_CONCURRENT_MESSAGE;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/notification/lib/notification_constants.js